import React, { useMemo } from 'react'
import { Card, Dropdown, Tooltip } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { path } from '../../../libs'
import { InProgress } from '../walletCard/types'
import { getFinsystemNumberFormat } from '../../../libs/utils'
import styles from './styles.module.css'

type Props = {
  data: InProgress
}

export const InProcessCard: React.FC<Props> = ({ data }) => {
  const { localBalances } = data

  const currencies = useMemo(
    () => localBalances.map((item) => item.currency),
    [localBalances],
  )

  const total = useMemo(
    () => localBalances.reduce((sum, item) => sum + item.sumUSD, 0),
    [localBalances],
  )

  const visibleBalances = localBalances.slice(0, 3)
  const hasOverflow = localBalances.length > 3

  const dropdownItems = useMemo(
    () =>
      localBalances.map((item, index) => ({
        label: `${item.sum} ${item.currency}`,
        key: index,
      })),
    [localBalances],
  )

  const goToDetails = () => {
    window.open(path.finSystem.wallets.inProgressDetails(), '_blank')
  }

  return (
    <Card className={styles.card} onClick={goToDetails}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.title}>In process</span>
          <Tooltip title={currencies.join(' ')}>
            <span className={styles.currencies}>{currencies.join(' ')}</span>
          </Tooltip>
        </div>

        <div className={styles.body}>
          <div className={styles.totalBlock}>
            <span className={styles.label}>Total sum</span>
            <span className={styles.totalAmount}>
              {getFinsystemNumberFormat(total, 2)}
              <span className={styles.totalUnit}>USD</span>
            </span>
          </div>
          <div className={styles.balanceBlock}>
            {hasOverflow ? (
              <Dropdown
                menu={{ items: dropdownItems }}
                placement="bottom"
                trigger={['hover', 'click']}
              >
                <span
                  className={styles.balanceTrigger}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                >
                  <span className={styles.label}>Local balance</span>
                  <DownOutlined style={{ color: '#9DA5B1' }} />
                </span>
              </Dropdown>
            ) : (
              <>
                <span className={styles.label}>Local balance</span>
                <div className={styles.balanceList}>
                  {visibleBalances.map((item, idx) => (
                    <span key={idx} className={styles.balanceRow}>
                      <span className={styles.balanceValue}>
                        {getFinsystemNumberFormat(item.sum, 8)}
                      </span>
                      <span className={styles.balanceCurrency}>
                        {item.currency}
                      </span>
                    </span>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  )
}
